<template>
  <section id="career" class="section">
    <div class="section-inner">
      <header v-reveal class="career-head">
        <span class="eyebrow">04 — carreira</span>
        <h2 class="section-title">De ERPs em Delphi a agentes de IA</h2>
        <p class="section-lead">
          Uma trajetória construída em camadas: primeiro o sistema, depois a
          web, agora a inteligência que roda em cima deles.
        </p>
      </header>

      <div class="career-grid">
        <div class="timeline">
          <h3 class="column-title mono">experiência</h3>

          <article
            v-for="(job, i) in experience"
            :key="job.company"
            v-reveal="i * 80"
            class="entry"
            :class="{ 'entry--current': job.current }"
          >
            <span class="entry-node"></span>

            <div class="entry-period mono">
              {{ job.period }}
              <span v-if="job.current" class="badge">atual</span>
            </div>

            <h4 class="entry-role">{{ job.role }}</h4>
            <p class="entry-company">{{ job.company }}</p>
            <p class="entry-desc">{{ job.description }}</p>
          </article>
        </div>

        <div class="education">
          <h3 class="column-title mono">formação</h3>

          <article
            v-for="(course, i) in education"
            :key="course.title"
            v-reveal="i * 80"
            class="edu-card"
            :class="{ 'edu-card--ongoing': course.ongoing }"
          >
            <div class="edu-period mono">
              {{ course.period }}
              <span v-if="course.ongoing" class="badge badge--ai">
                em andamento
              </span>
            </div>
            <h4 class="edu-title">{{ course.title }}</h4>
            <p class="edu-school">{{ course.school }}</p>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CareerPage",

  data() {
    return {
      experience: [
        {
          period: "Ago/2025 — hoje",
          role: "Desenvolvedor",
          company: "SAASONE",
          current: true,
          description:
            "Desenvolvimento de produtos web com Vue.js 3, Node.js e MongoDB, cobertura de testes com Jest e Cypress, e design system documentado em Storybook.",
        },
        {
          period: "Fev/2022 — hoje",
          role: "Desenvolvedor",
          company: "Comeia Labs",
          current: true,
          description:
            "Construção de plataformas SaaS escaláveis e arquitetura de times de agentes de IA — JurisOne e Nexia OS —, atuando também em infraestrutura cloud e automação de processos inteligentes.",
        },
        {
          period: "Mar/2018 — Abr/2022",
          role: "Desenvolvedor",
          company: "Longtech Software",
          description:
            "ERP personalizado em Delphi, SQL e Firebird. Levantamento de requisitos direto com o cliente, acompanhando do início ao fim da implantação.",
        },
      ],

      education: [
        {
          period: "2026 — 2027",
          title: "Pós-graduação em Engenharia de Software em IA Aplicada",
          school: "Anhanguera",
          ongoing: true,
        },
        {
          period: "2024 — 2025",
          title: "Pós-graduação em Engenharia de Software",
          school: "UniFavip Wyden",
        },
        {
          period: "2018 — 2021",
          title: "Análise e Desenvolvimento de Sistemas",
          school: "UniFavip Wyden",
        },
        {
          period: "Abr/2021 — Abr/2024",
          title: "Desenvolvimento de software mobile e programação web",
          school: "Secretaria de Educação de Pernambuco — EaD",
        },
      ],
    };
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
